import { NO_STREAMS, LOADING, SUCCESS_STREAMS, SELECT_STREAM, SUCCESS_FILTERS, SUCCESS_DATA, SUCCESS_COMPARISON_DATA, UPDATE_DATES, UPDATE_DATE_RANGE } from './ReportActions';

const INITIAL_STATE = {  
  noStreams: false,
  isLoading: false,
  settings: {
    dashboards: [],
  },
  streams: [],
  filters: {
    dashboards: [],
  },
  stats: {},
  trends: {},
  comparison: {},
  selectedStream: {}
};

const ReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NO_STREAMS: {
      return { ...state, noStreams: true, loaded: true, selectedStream:{}, streams: [], issue: '' };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS_STREAMS: {
      return { ...state, isLoading: false, streams: action.streams };
    }
    case SELECT_STREAM: {
      return { ...state, isLoading: false, noStreams: false, selectedStream: action.selected, viewId: action.viewId,  };
    }
    case SUCCESS_FILTERS: {
      return { ...state, filters: action.filters };
    }
    case SUCCESS_DATA: {
      return { ...state, isLoading: false, stats: action.data.stats, trends: action.data.trends };
    }
    case SUCCESS_COMPARISON_DATA: {
      return { ...state, isLoading: false, comparison: action.data.comparison };
    }
    case UPDATE_DATE_RANGE: {
      return { ...state, dateRange: action.data };
    }
    case UPDATE_DATES: {
      return { ...state, dates: action.data };
    }
    default:
      return state;
  }
};

export default ReportReducer;
